module.exports = "https://p.cds.unp.clasificados.pe/payment-success-vehicle.05fb06a7736a45bf3197dbcb16435345.png";